import { statusMeta } from "@/lib/constants";

export default function StatusBadge({ status, testId }) {
  const s = statusMeta(status);
  return (
    <span
      className={`inline-flex items-center gap-2 px-2.5 py-1 rounded-md text-xs font-medium border ${s.chip}`}
      data-testid={testId || `status-badge-${status}`}
    >
      <span className={`status-dot ${s.dot}`} />
      {s.label}
    </span>
  );
}
